<template>
    <div>
        <v-snackbar top :timeout="3000" v-model="snackbar">{{snackbarText}}</v-snackbar>
        <v-card class="d-flex flex-column">
                <v-card-title class="grid-close">
                <span class="headline">Archivos seleccionados</span>
                <v-btn
                    style="right:10px; top:10px;"
                    icon
                    color="primary"
                    fab
                    absolute
                    @click="$emit('cancel')"
                    v-if="!loading"
                    >
                    <v-icon dark>fa-times</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
            <v-container v-if="!loading" fluid>
                <v-row v-for="(item, index) of files" :key="index" >
                    <v-col cols="4" sm="4" md="4">
                        {{details[index]}}
                        <!-- <img :src="details[index].src"> -->
                    </v-col>
                    <v-col cols="8" sm="8" md="8">
                        <v-text-field
                            v-model="details[index].name"
                            label="Nombre de la imagen"
                            clearable
                            autofocus
                            rounded
                            filled
                        ></v-text-field>
                        <v-progress-linear
                            :value="details[index].progress"
                            color="primary"
                            style="border-radius: 20px;"
                            class="mt-3"
                            height="30"
                            >
                            <strong>{{ Math.ceil(details[index].progress) }}%</strong>
                        </v-progress-linear>
                    </v-col>
                </v-row>
                    
                <v-row class="pa-0 ma-0">
                    <v-col cols="12" sm="12" md="12">
                        <v-row justify="end">
                            <v-btn :loading="loading" class="save-btn" @click="save()" color="primary">Guardar</v-btn>
                        </v-row>
                    </v-col>
                </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { db, fb } from "@/firebase";
import { mapActions, mapState } from 'vuex';

export default {
  name: "edit-image",
  props : ['files'],
  data() {
   return {
      snackbarText : '',
      snackbar : false,
      loading: true,
      details : [],
    //   defaultImage : require('@/assets/defaultImage.svg'),
    }
  },
  computed: {
    ...mapState(['user'])
  },
  methods: {
    generateSrc( item ) {
        return new Promise((resolve, reject) => {
            var reader = new FileReader(); 
            reader.onload = (e) => {
               resolve(e.target.result)
            }

            reader.readAsDataURL(item); 
        })
    }
//    async save() {
//         if ( this.editedImage.name ) {
//             this.loading = true
//             db.collection('files').doc(this.image[".key"]).update({
//                 name : this.editedImage.name
//             }).then( response => {
//                this.editedImage = ''
//                this.loading = false
//                this.$emit('success')
//             })
//             .catch( err => {
//                 this.loading = false
//                 this.snackbarText = 'Ocurrió un error inesperado, inténtelo nuevamente.'
//                 this.snackbar = true
//             })
//         } else {
//             this.snackbarText = 'Ingrese el nombre de la imagen.'
//             this.snackbar = true
//         }
//     }
  },
  async mounted() {    
    this.files.forEach(async (item, index) => {
        let src = await this.generateSrc( item )
        console.log(src);

        this.details[index] = {
            name : item.name ? item.name : 'Desconocido',
            progress : 0,
            src : src
        }            
    })
    this.loading = false
    console.log('sagagasajsn');
  }
}
</script>